import React from 'react';

import styled from 'styled-components';

import GearsIcon from './gears-icon';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 140px);
  justify-content: center;
  padding: 0 3rem;

  ${Styles.desktop`
    height: calc(100vh - 275px - 12rem);
    margin-top: 12rem;
  `}
`;

const StyledGearIcon = styled(GearsIcon)`
  margin: 1rem 0.5rem;
  max-width: 180px;
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Header = styled.h1`
  font-size: 1.625rem;
  color: ${Styles.color.grey.one};
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.heavy};
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
`;

const Subtext = styled.p`
  align-items: center;
  display: flex;
  color: ${Styles.color.grey.two};
  flex-direction: column;
  line-height: 1;
  /* margin: 1.5rem 0.5rem; */
  max-width: 400px;
  text-align: center;
  text-align: center;
`;

const SiteUpdating = () => {
  return (
    <div>
      <Container>
        <StyledGearIcon />
        <Content>
          <Header>We'll Be Right Back!</Header>
          <Subtext>
            We're doing some work behind the scenes to improve your experience. We'll have
            everything back up and running in a few minutes.
          </Subtext>
        </Content>
      </Container>
    </div>
  );
};

export default SiteUpdating;
